const outputDoc = {
  title: 'Testamento',
  from: 'da',
  born: ' nato il ',
  civilStatus: {
    single: 'Celibe/Nubile',
    married: 'Sposato/a',
    widowed: 'Vedovo/a',
    divorced: 'Divorziato/a',
    registered_partnership: 'Partenariato registrato',
  },
  civil_status: 'Stato civile: {{civil_status}}',
  address: 'Indirizzo: {{address}}',
  declare: 'Io, {{first_name}} {{last_name}}, dichiaro quanto segue:  ',

  paragraph1: 'Revoco tutti i testamenti che ho redatto in precedenza.',

  paragraph2:
    "Le passività correnti e i costi del decesso devono essere pagati dall'eredità.",

  paragraph3: '{{civil_status}}',

  receivesNothing: 'non riceve nulla.',

  and: 'e',

  p4MarriedSpouse: {
    marriedStatus: {
      male: 'Mia moglie',
      female: 'Mio marito',
    },
    livingPartnershipStatus: {
      male: 'La mia partner registrata',
      female: 'Il mio partner registrato',
    },
    partnerStatus: {
      male: 'La mia partner',
      female: 'Il mio partner',
    },
    born: ', nato il {{birthday}}, ',
    receivesAsHeir: 'riceve come erede tutta la quota disponibile.',
  },

  marriedSpouseChildren: {
    biologicalChildren: {
      oneChild: {
        main: 'Il mio figlio biologico e legalmente riconosciuto ',
        born: ', nato il {{birthday}}, ',
        receive: 'riceve la sua quota legittima della mia successione.',
      },
      multipleChildren: {
        main: 'I miei figli biologici e legalmente riconosciuti ',
        born: ', nati il {{birthday}}, ',
        receive:
          'ricevono ciascuno la loro quota legittima della mia successione.',
      },
    },
  },

  marriedSpouseUsufruct: {
    marriedStatus: {
      male: 'A mia moglie',
      female: 'A mio marito',
    },
    livingPartnershipStatus: {
      male: 'Alla mia partner registrata',
      female: 'Al mio partner registrato',
    },
    usufructRights:
      'concedo inoltre il vitalizio usufrutto sulla quota legittima dei miei figli.',
  },

  p4UnmarriedPartner: {
    receives: "riceve l'intera quota liberamente disponibile.",
    receivesProperty: 'riceve in particolare anche',
    theProperty: 'la proprietà',
    atTheAddress: "all'indirizzo",
    assignedToProperty: 'assegnata in proprietà.',
    born: ', nato il {{birthday}}, ',
    genderStatus: {
      male: 'La mia compagna di vita',
      female: 'Il mio compagno di vita',
      male1: 'la mia compagna di vita',
      female1: 'il mio compagno di vita',
      registeredPartnerMale: 'La mia partner registrata',
      registeredPartnerFemale: 'Il mio partner registrato',
    },
  },

  p5UnmarriedPartnerWithChildren: {
    commonPartnership: {
      oneChild: {
        main: 'Il nostro figlio comune, ',
        born: ', nato il {{birthday}}, ',
        receive: 'o i suoi discendenti ricevono la quota legittima.',
      },
      multipleChildren: {
        main: 'I nostri figli comuni, ',
        born: ', nati il {{birthday}}, ',
        receive:
          'o tutti i loro discendenti ricevono ciascuno la quota legittima.',
      },
      and: 'e',
    },
    otherPartnership: {
      oneChild: {
        main: 'Il mio figlio non comune, ',
        born: ', nato il {{birthday}}, ',
        receive: 'o i suoi discendenti ricevono la quota legittima.',
      },
      multipleChildren: {
        main: 'I miei figli non comuni, ',
        born: ', nati il {{birthday}}, ',
        receive:
          'o tutti i loro discendenti ricevono ciascuno in parti uguali la quota legittima.',
      },
    },
    noPartnership: {
      oneChild: {
        main: 'Il mio figlio, ',
        born: ', nato il {{birthday}}, ',
        receive: ' o i suoi discendenti ricevono la quota legittima.',
      },
      multipleChildren: {
        main: 'I miei figli, ',
        born: ', nati il {{birthday}}, ',
        receive:
          ' o tutti i loro discendenti ricevono ciascuno la quota legittima.',
      },
    },
    deathCase:
      'Se dovessi morire contemporaneamente a {{partner}}, allora {{childrenCase}}',
    born: ', nato il {{birthday}}, ',
    childrenCase: {
      oneChild: {
        fromCommonMarriage: 'riceve il nostro figlio comune, ',
        fromOtherMarriage: 'riceve il nostro figlio non comune, ',
        fromUnknownMarriage: 'riceve il mio figlio,',
      },
      onesDescendants: 'o i suoi discendenti tutti i beni.',
      multipleChildren: {
        fromCommonMarriage: 'ricevono i nostri figli comuni, ',
        fromOtherMarriage: 'ricevono i nostri figli non comuni, ',
        fromUnknownMarriage: 'ricevono i miei figli, ',
      },
      allDescendants: 'o tutti i loro discendenti ciascuno tutti i beni.',
    },
  },

  p4Child: {
    biologicalChildren: {
      oneChild: {
        main: 'Nomino mio figlio ',
        born: ', nato il {{birthday}}, ',
        receive:
          'erede di tutta la mia successione. Riceve tutta la mia successione.',
      },
      multipleChildren: {
        main: 'Nomino i miei figli ',
        born: ', nati il {{birthday}}, ',
        receive:
          'in parti uguali come eredi di tutta la mia successione. Ricevono ciascuno metà della mia successione.',
      },
    },
    partnerCase: {
      male: 'Mia moglie',
      female: 'Mio marito',
      born: ', nato il {{birthday}}, ',
      receivesNothing:
        'non riceverà alcuna assegnazione dalla mia successione.',
      receivesCompulsoryPortion:
        'riceve la sua quota legittima dalla mia successione.',
    },
  },

  unmarriedChildrenChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'Nomino mio figlio ',
        born: ', nato il {{birthday}}, ',
        receive:
          'erede di tutta la mia successione. Riceve tutta la mia successione.',
      },
      multipleChildren: {
        main: 'Nomino i miei figli ',
        born: ', nati il {{birthday}}, ',
        receive:
          'in parti uguali come eredi di tutta la mia successione. Ricevono ciascuno metà della mia successione.',
      },
    },
  },

  unmarriedPartnerCase: {
    male: 'La mia compagna di vita',
    female: 'Il mio compagno di vita',
    born: ', nato il {{birthday}}, ',
    receivesNothing: 'non deve ricevere alcuna assegnazione dalla mia eredità.',
  },

  unmarriedPartnerDeathCase: {
    male: "Se dovessi morire contemporaneamente alla mia compagna di vita o lei non sopravvive all'evento successorio, allora riceve",
    female:
      "Se dovessi morire contemporaneamente al mio compagno di vita o lui non sopravvive all'evento successorio, allora riceve",
    multipleChildren: 'il mio figlio, ',
    oneChild: 'il mio figlio, ',
    born: ', nato il {{birthday}}, ',
    descendants: 'o i suoi discendenti',
    multipleDescendants: 'o i loro discendenti',
    inheritAll:
      "l'intera eredità in parti uguali con altri eredi (se presenti) o da solo se non esistono altri eredi legali.",
    and: 'nonché',
  },

  unmarriedInstitutionChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'Il mio figlio biologico e legalmente riconosciuto, ',
        born: ', nato il {{birthday}}, ',
        receive: 'riceve la sua quota legittima della mia eredità.',
      },
      multipleChildren: {
        main: 'I miei figli biologici e legalmente riconosciuti, ',
        born: ', nati il {{birthday}}, ',
        receive: 'ricevono ciascuno la loro quota legittima della mia eredità.',
      },
    },
  },

  p4Institution: {
    oneInstitution: {
      main: "L'istituzione",
      receives: 'riceve',
    },
    multipleInstitutions: {
      main: 'Le istituzioni',
      receives: 'ricevono',
    },
    finals:
      ' ciascuno in parti uguali tutti i beni nel quadro della quota liberamente disponibile. ',
    final: ' tutti i beni nel quadro della quota liberamente disponibile. ',
    partnerReceives: 'riceve la sua quota legittima dalla mia eredità.',
    born: ', nato il {{birthday}}, ',
    and: ' e ',
  },

  p5MarriedSpouse: {
    marriedStatus: {
      male: 'Mia moglie',
      female: 'Mio marito',
    },
    livingPartnershipStatus: {
      male: 'La mia partner registrata',
      female: 'Il mio partner registrato',
    },
    particularReceives: {
      marriedStatus:
        "Mia moglie deve ricevere la proprietà a {{address}} in piena proprietà nell'ambito della quota disponibile. Se la quota disponibile non è sufficiente a tal fine, l'assegnazione deve essere effettuata con imputazione sulla sua quota ereditaria.",
      livingPartnershipStatus:
        "La mia partner registrata deve ricevere la proprietà a {{address}} in piena proprietà nell'ambito della quota disponibile. Se la quota disponibile non è sufficiente a tal fine, l'assegnazione deve essere effettuata con imputazione sulla sua quota ereditaria.",
    },
    theProperty: 'la proprietà',
    atTheAddress: "all'indirizzo",
    assignedToProperty: 'assegnato come proprietà.',
  },

  spouseSimultaneousDeathClause:
    "Se {{partnerTerminology}} {{partnerFullNameAndBirthday}} dovesse morire contemporaneamente a me o non sopravvivere all'evento di successione, la quota disponibile della mia eredità passa ai miei due figli {{childrenNames}} in parti uguali.",

  p5Institution: {
    commonMarriage: {
      oneChild: {
        main: 'Il nostro figlio comune, ',
        born: ' nato il {{birthday}}, ',
        receive: 'o i suoi discendenti ricevono la quota legittima.',
      },
      multipleChildren: {
        main: 'I nostri figli comuni, ',
        born: ' nati il {{birthday}}, ',
        receive:
          'o tutti i loro discendenti ricevono ciascuno la quota legittima.',
      },
      and: 'e',
    },
    otherMarriage: {
      oneChild: {
        main: 'Il mio figlio non comune, ',
        born: ' nato il {{birthday}}, ',
        receive: 'o i suoi discendenti ricevono la quota legittima.',
      },
      multipleChildren: {
        main: 'I miei figli non comuni, ',
        born: ' nati il {{birthday}}, ',
        receive:
          'o tutti i loro discendenti ricevono ciascuno la quota legittima.',
      },
      and: 'e',
    },
  },

  p6MarriedSpouse: {
    oneChild: {
      commonMarriage: 'Il nostro figlio comune, ',
      otherMarriage: 'Il mio figlio non comune, ',
      born: ', nato il {{birthday}}, ',
      receives: 'o i suoi discendenti ricevono ',
    },
    multipleChildren: {
      commonMarriage: 'I nostri figli comuni, ',
      otherMarriage: 'I miei figli non comuni, ',
      born: ', nati il {{birthday}}, ',
      receives: 'o tutti i loro discendenti ricevono ciascuno',
    },
    final:
      "la quota legittima, gravata tuttavia dall'usufrutto menzionato nel primo paragrafo. ",
  },

  willExecutor:
    'Nomino {{executor1}} come esecutore testamentario per tutta la mia eredità. Nomino {{executor2}} come esecutore testamentario sostitutivo.',

  forFollowing: {
    main: 'Per i seguenti beni si applica tuttavia una disposizione diversa:',
    asset: '{{asset}}, {{address}} va a: {{benefiter}}. ',
    devisionProvision:
      'Questa è una disposizione di divisione a favore di {{benefiter}}, non un ulteriore beneficio.',
  },
  optionalUsufruct: {
    marriedMale: 'Mia moglie',
    marriedFemale: 'Mio marito',
    partnerMale: 'La mia partner registrata',
    partnerFemale: 'Il mio partner registrato',
    receives: ' riceve il diritto di usufrutto vitalizio',
    propertyPart: ' sulla mia proprietà a {{address}}',
    andOr: ' e/o',
    estatePart:
      ' su parti della mia eredità, nella misura in cui ciò sia compatibile con i diritti degli eredi legali o designati.',
  },
};

export default outputDoc;
